import React, { useState } from "react"
import { createBrowserRouter, RouterProvider, Outlet } from "react-router";
import { RootRouter } from "../../app";
import { MainMenu } from "../data.types";

import { startRouterCliente } from "../modulos/cliente/cliente.router";
import { startRouterFornecedor } from "../modulos/fornecedor/forn.router";
import { startRouterFuncionario } from "../modulos/funcionario/funcionario.router";
import { startRouterMeioPag } from "../modulos/meioPag/meiopg.router";
import { startRouterItem } from "../modulos/item/item.router";
import { ProvideAuth, RequireAuth } from "../modulos/logIn/view";
import { startRouterLogIn } from "../modulos/logIn/logIn.router";
import { routerMovCadastro, startRouterTipoMov } from "../modulos/tipoMov/tipomov.router";
import { startRouterCanalDist } from "../modulos/canalDist/canalDist.router";
import { startRouterMain } from "../modulos/mainPanel/mainPanel.router"
import { routerContaDetalhe, startRouterContas } from "../modulos/contas/contas.router";
import { startRouterSettings } from "../modulos/settings/settings.router"

//rotas
export const AninharView = Outlet;
export const menuRotas: MainMenu[] = [];

const WrapperRootPage = () => {
    return (
        <RequireAuth>
            <RootRouter />
        </RequireAuth>
    )
}

export const rotas = createBrowserRouter([
    startRouterLogIn(),
    {
        path: "/",
        element: <WrapperRootPage/>,
        children: [
            startRouterMain(),
            startRouterCliente(),
            startRouterFornecedor(),
            startRouterFuncionario(),
            startRouterMeioPag(),
            startRouterItem(),
            startRouterTipoMov(),
            startRouterCanalDist(),
            startRouterContas(),
            routerContaDetalhe,
            startRouterSettings(),
        ],
    },
])


export const Roteador = () => {
    return (
        <ProvideAuth>
            <RouterProvider router={rotas} />
        </ProvideAuth>
    )
}